const playIcon = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 6.5v11l9-5.5z" fill="currentColor" /></svg>`;
const stopIcon = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="7" y="7" width="10" height="10" fill="currentColor" /></svg>`;
const animationStorageKey = "animation-toggle-state";

export const initAnimationToggle = () =>
{
    const animationToggle = document.createElement("button");

    animationToggle.className = "animation-toggle";
    animationToggle.type = "button";

    try
    {
        if (sessionStorage.getItem(animationStorageKey) === "animated")
        {
            document.body.classList.add("animated");
        }
    }
    catch
    {
    }

    const syncAnimationToggle = () =>
    {
        const animated = document.body.classList.contains("animated");

        animationToggle.innerHTML = animated ? stopIcon : playIcon;
        animationToggle.setAttribute("aria-pressed", String(animated));
        animationToggle.setAttribute("aria-label", `${animated ? "Stop" : "Play"} background animation`);
    };

    animationToggle.addEventListener("click", () =>
    {
        document.body.classList.toggle("animated");

        try
        {
            sessionStorage.setItem(animationStorageKey, document.body.classList.contains("animated") ? "animated" : "stopped");
        }
        catch
        {
        }

        syncAnimationToggle();
    });

    syncAnimationToggle();
    document.body.appendChild(animationToggle);
};
